"use client";

import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
	return (
		<SonnerToaster
			theme="dark"
			position="bottom-right"
			toastOptions={{
				style: {
					background: "var(--surface)",
					border: "1px solid var(--border)",
					color: "var(--foreground)",
				},
			}}
		/>
	);
}
